/* eslint-disable import/no-anonymous-default-export */
/* eslint-disable no-unused-vars */
import { getRateHistory } from '../../services/chartServices.js';
import { subscribeOnStream, unsubscribeFromStream } from './index.jsx';
// import {
// 	subscribeOnStream,
// 	unsubscribeFromStream,
// } from './streaming.js';
let serverTimeZone = !!sessionStorage.getItem('timezone') ? sessionStorage.getItem('timezone') : "";
  if (!!serverTimeZone) {
    serverTimeZone = JSON.parse(serverTimeZone)?.value;
  }
const lastBarsCache = new Map();

// DatafeedConfiguration implementation
const resolutionsDic = {
	1: "1",
	'5': '5',
	15: "15",
	30: "30",
	'60': '1H',
	'180': '3H',
	"1D": "1D",
	'1W': '1W',
	'1M': '1M',
  };
const configurationData = {
	// Represents the resolutions for bars supported by your datafeed
	supported_resolutions: ['1', '5', '15', '30', '60', '1D'],//, '1W', '1M'],//['1', '5', '10'],//['1', '5', '15', '30', '60', '1D', '1W', '1M'],
	supports_marks: true,
    supports_search: false,
    supports_timescale_marks: true,
    supports_time: true,
	// The `exchanges` arguments are used for the `searchSymbols` method if a user selects the exchange
	exchanges: [{
		value: 'MetaOdds',
		name: 'MetaOdds',
		desc: 'MetaOdds',
	},
	],
	// The `symbols_types` arguments are used for the `searchSymbols` method if a user selects this symbol type
	symbols_types: [
		// {
		// 	name: 'MCX',
		// 	value: 'MCX',
		// },
	],
};

// Obtains all symbols for all exchanges supported by CryptoCompare API
async function getAllSymbols() {
	// const data = await makeApiRequest('data/v3/all/exchanges');
	let allSymbols = [];

	// for (const exchange of configurationData.exchanges) {
	// 	const pairs = data.Data[exchange.value].pairs;

	// 	for (const leftPairPart of Object.keys(pairs)) {
	// 		const symbols = pairs[leftPairPart].map(rightPairPart => {
	// 			const symbol = generateSymbol(exchange.value, leftPairPart, rightPairPart);
	// 			return {
	// 				symbol: symbol.short,
	// 				full_name: symbol.full,
	// 				description: symbol.short,
	// 				exchange: exchange.value,
	// 				type: 'crypto',
	// 			};
	// 		});
	// 		allSymbols = [...allSymbols, ...symbols];
	// 	}
	// }
	return allSymbols;
}

export default {
	onReady: (callback) => {
		console.log('[onReady]: Method call');
		setTimeout(() => callback(configurationData));
	},

	searchSymbols: async (
		userInput,
		exchange,
		symbolType,
		onResultReadyCallback,
	) => {
		// console.log('[searchSymbols]: Method call');
		// const symbols = await getAllSymbols();
		// const newSymbols = symbols.filter(symbol => {
		// 	const isExchangeValid = exchange === '' || symbol.exchange === exchange;
		// 	const isFullSymbolContainsInput = symbol.full_name
		// 		.toLowerCase()
		// 		.indexOf(userInput.toLowerCase()) !== -1;
		// 	return isExchangeValid && isFullSymbolContainsInput;
		// });
		// onResultReadyCallback(newSymbols);
	},

	resolveSymbol: async (
		symbolName,
		onSymbolResolvedCallback,
		onResolveErrorCallback,
		extension
	) => {
		console.log('[resolveSymbol]: Method call', symbolName);
		// const symbols = await getAllSymbols();
		// const symbolItem = symbols.find(({
		// 	full_name,
		// }) => full_name === symbolName);
		const symbl = symbolName.split('=');
		const symbolItem = {
			symbol: symbl[0],
			full_name: symbl[0],
			description: symbl[0],
			exchange: 'MetaOdds',
			type: 'MCX',
			masterSymbol: symbl[1],
			symbolDigits: symbl[2]
		}
		if (!symbolItem) {
			console.log('[resolveSymbol]: Cannot resolve symbol', symbolName);
			onResolveErrorCallback('cannot resolve symbol');
			return;
		}
		// Symbol information object
		const symbolInfo = {
			ticker: symbolItem.full_name,
			name: symbolItem.symbol,
			description: symbolItem.description,
			type: symbolItem.type,
			session: '24x7',
			timezone: serverTimeZone,
			exchange: symbolItem.exchange,
			minmov: 1,
			pricescale: 10 ** parseInt(symbolItem.symbolDigits),
			has_intraday: true,
			has_no_volume: true,
			has_weekly_and_monthly: true,
			supported_resolutions: configurationData.supported_resolutions,
			volume_precision: 2,
			data_status: 'streaming',
			masterSymbol: symbolItem.masterSymbol,
		};

		console.log('[resolveSymbol]: Symbol resolved', symbolName);
		onSymbolResolvedCallback(symbolInfo);
	},

	getBars: async (symbolInfo, resolution, periodParams, onHistoryCallback, onErrorCallback) => {
		// getBars: async (
		// 	symbolInfo,
		// 	resolution,
		// 	from,
		// 	to,
		// 	onHistoryCallback,
		// 	onErrorCallback,
		// 	firstDataRequest,
		//   ) => {
		// const { from, to, firstDataRequest } = periodParams;
		console.log('[getBars]: Method call', symbolInfo, resolution, periodParams.from, periodParams.to);
		const countback = periodParams.countBack;
		// console.log('periodParams');
		// console.log(periodParams);
		console.log('------------');

		let frm = !!periodParams && periodParams.from ? parseInt(periodParams.from * 1000) : '';

		if(periodParams.firstDataRequest && resolution === '1' ){
			if(`${new Date(periodParams.from * 1000).getFullYear()}${new Date(periodParams.from * 1000).getMonth()}${new Date(periodParams.from * 1000).getDate()}`===`${new Date().getFullYear()}${new Date().getMonth()}${new Date().getDate()}`){
				let multiplier = new Date(periodParams.from * 1000).getDay();
				multiplier=multiplier === 6 ? 1 :(multiplier === 0 ? 2 : 0);
				frm = (frm - (86400000 * multiplier));
			}
		}

		let params = {
			"Symbol"   : symbolInfo.masterSymbol, //'GOLD23DECFUT',//symbolInfo.full_name,
			"fromDate" : frm,//!!periodParams && periodParams.from ? parseInt(periodParams.from * 1000) : '',
			"toDate"   : !!periodParams && periodParams.to ? parseInt(periodParams.to * 1000) : '',
			"interval" : resolutionsDic[resolution]//resolution
		}
		try {
			const data = await getRateHistory(params);//await makeApiRequest(`data/histoday?${query}`);
			// if(!!data && data.isSuccess && !!data.data){

			// let dataArr = data.data; //.split('\r\n');
			

			// // if(!(!!dataArr && dataArr.length>0)){
			// // 	onHistoryCallback([], {
			// // 		noData: true,
			// // 	});
			// // 	return;
			// // }

			// let bars = [];
			// dataArr.forEach(bar => {
				
			// 	let splitedBar = bar; 
			// 	if ((splitedBar.updateTime/1000) >= periodParams.from && (splitedBar.updateTime/1000) < periodParams.to) {
			// 		bars = [...bars, {
			// 			time: splitedBar.updateTime,
			// 			low: splitedBar.lowBid,
			// 			high: splitedBar.highBid,
			// 			open: splitedBar.openBid,
			// 			close: splitedBar.closeBid,
			// 		}];
			// 	}
			// });
			// if (periodParams.firstDataRequest) {
			// 	lastBarsCache.set(symbolInfo.full_name, {
			// 		...bars[bars.length - 1],
			// 	});
			// }
			// console.log(`[getBars]: returned ${bars.length} bar(s)`);
			// if(bars.length > 0) {
			// 	onHistoryCallback(bars, {
			// 		noData: true, // !periodParams.firstDataRequest,
			// 	});
			// } else {
			// 	onHistoryCallback([], {
			// 		noData: true, // !periodParams.firstDataRequest,
			// 	});
			// }
			// } else {
			// 	onHistoryCallback([], {
			// 		noData: true,
			// 	});
			// }
			if (data.isSuccess) {
        
				let bars = [];
				const bar = data.data.map((item) => {
				  return {
					time: item.updateTime,
					low: item.lowBid,
					high: item.highBid,
					open: item.openBid,
					close: item.closeBid,
					volume: item.volume,
				  };
				});
				bars = [...bars, ...bar];
		
				if (periodParams.firstDataRequest) {
				  lastBarsCache.set(symbolInfo.name, {
					...bars[bars.length - 1],
				  });
				}
		
				console.log(`[getBars]: returned ${bars.length} bar(s)`);
				if (bars.length > 0) {
				  onHistoryCallback(bars, {
					noData: true, // !periodParams.firstDataRequest,
				  });
				} else {
				  onHistoryCallback([], {
					noData: true, // !periodParams.firstDataRequest,
				  });
				}
				// onHistoryCallback(bars, {noData: false});
			  } else {
				console.error("Failed to fetch data:");
			  }
		} catch (error) {
			console.log('[getBars]: Get error', error);
			onErrorCallback(error);
		}
	},

	subscribeBars: (
		symbolInfo,
		resolution,
		onRealtimeCallback,
		subscriberUID,
		onResetCacheNeededCallback,
	) => {
		console.log('[subscribeBars]: Method call with subscriberUID:', subscriberUID);
		subscribeOnStream(
			symbolInfo,
			resolution,
			onRealtimeCallback,
			subscriberUID,
			onResetCacheNeededCallback,
			lastBarsCache.get(symbolInfo.full_name),
		);
	},

	unsubscribeBars: (subscriberUID) => {
		console.log('[unsubscribeBars]: Method call with subscriberUID:', subscriberUID);
		unsubscribeFromStream(subscriberUID);
	},
};
